var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8B572E;}\n\t.st1{fill:#F1D0A5;}\n\t.st2{fill:#B16E3D;}\n\t.st3{fill:#F1B986;}\n\t.st4{fill:#454045;}\n\t.st5{fill:#595959;}\n\t.st6{fill:#454545;}\n\t.st7{fill:#2B282B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 381,
    cy: 57.3,
    r: 57.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 381,
    cy: 57.3,
    r: 28.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 131,
    cy: 57.3,
    r: 57.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131,
    cy: 57.3,
    r: 28.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.9,247c0,0,95.7,71.6,59,131.9L256,507V218.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.1,247c0,0-95.7,71.6-59,131.9L256,507V218.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M415.6,384.3c0,27.7-7.1,50.2-19.5,67.9C369,490.8,316.4,507,256,507c-33.5,0-64.6-5-90.3-16 c-41.9-18-69.3-52-69.3-106.6c0-29.4,8-61.1,21.9-90.3c27.7-58.2,79-106.3,137.7-106.3c58.7,0,110,48.1,137.7,106.3 C407.6,323.2,415.6,354.9,415.6,384.3L415.6,384.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.7,294c-27.7,36.3-79,51.6-137.7,51.6c-58.7,0-110-15.3-137.7-51.6c27.7-58.2,79-106.3,137.7-106.3 C314.7,187.8,366,235.8,393.7,294z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.6,458.7c-41.1,13-78.8,12.7-109.9,5.9c-37.4-8.2-64-41.3-64.1-79.5c0-0.2,0-0.5,0-0.7 c0-88.2,22.1-196.6,65.4-196.6c-88.1,0-159.6,108.4-159.6,196.6c0,54.7,27.6,82.7,69.6,96l-0.3,10.6c25.7,11,56.8,16,90.3,16 c60.4,0,113-16.2,140.1-54.8C387.6,452.7,377.2,454.7,364.6,458.7L364.6,458.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M415.6,196.6c0,88.2-71.5,122.7-159.6,122.7S96.4,284.7,96.4,196.6S167.8,0,256,0S415.6,108.4,415.6,196.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,319.2c-88.2,0-159.6-34.5-159.6-122.7C96.4,108.4,167.8,0,256,0c-52.7,0-95.5,108.4-95.5,196.6 C160.5,284.7,203.3,319.2,256,319.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.5,223.1c0,25-12.8,40.3-32.2,48.3c-6.4,2.6-13.4,4.4-21,5.5c-5.8,0.8-12,1.2-18.3,1.2s-12.4-0.4-18.3-1.2 c-7.6-1.1-14.7-2.9-21-5.5c-19.4-7.9-32.2-23.3-32.2-48.3c0-39.5,32-88.1,71.5-88.1S327.5,183.6,327.5,223.1L327.5,223.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.1,278c-39.1-0.2-70.6-15.8-70.6-54.9c0-39.5,32-88.1,71.5-88.1c-20.4,0-37,48.6-37,88.1 C219,261.9,235.1,277.5,255.1,278z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 398.4,
    cy: 423.6,
    rx: 77.1,
    ry: 88.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.6,508.9c-6.4,2-13.2,3.1-20.2,3.1c-42.6,0-77.1-39.6-77.1-88.4s34.5-88.4,77.1-88.4 c7,0,13.8,1.1,20.2,3.1c-32.8,10.2-56.8,44.5-56.8,85.3S385.9,498.7,418.6,508.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 113.6,
    cy: 423.6,
    rx: 77.1,
    ry: 88.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.8,508.9c-6.4,2-13.2,3.1-20.2,3.1c-42.6,0-77.1-39.6-77.1-88.4s34.5-88.4,77.1-88.4 c7,0,13.8,1.1,20.2,3.1c-32.8,10.2-56.8,44.5-56.8,85.3S101,498.7,133.8,508.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 179,
    cy: 135,
    rx: 15,
    ry: 22.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 333,
    cy: 135,
    rx: 15,
    ry: 22.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M263.7,195.3V224c0,11.1-2.8,21.7-7.7,31.1c-4.4,8.4-10.6,15.8-18.3,21.7c-7.6-1.1-14.7-2.9-21-5.5 c0.2-0.1,0.5-0.3,0.8-0.4c18.7-8.1,30.8-26.6,30.8-47v-28.7c0-4.3,3.5-7.7,7.7-7.7C260.3,187.6,263.7,191,263.7,195.3L263.7,195.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M295.3,271.3c-6.4,2.6-13.4,4.4-21,5.5c-7.6-5.9-13.8-13.3-18.3-21.7c-5-9.4-7.7-20.1-7.7-31.1v-28.7 c0-4.3,3.5-7.7,7.7-7.7c4.3,0,7.7,3.5,7.7,7.7V224c0,20.4,12.1,38.8,30.8,47C294.8,271,295,271.2,295.3,271.3L295.3,271.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 107.7,
    cy: 454.8,
    r: 34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 76.8,
    cy: 394.7,
    r: 13.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 116,
    cy: 373.6,
    r: 13.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 151.7,
    cy: 400.5,
    r: 13.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 404.3,
    cy: 454.8,
    r: 34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 435.2,
    cy: 394.7,
    r: 13.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 396,
    cy: 373.6,
    r: 13.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 360.3,
    cy: 400.5,
    r: 13.3
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 256,
    cy: 165.1,
    rx: 40.9,
    ry: 30.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M269.7,193.5c-4.3,1.1-8.9,1.7-13.7,1.7c-22.6,0-40.9-13.5-40.9-30.1c0-16.6,18.3-30.1,40.9-30.1 c4.8,0,9.4,0.6,13.7,1.7c-15.8,4.2-27.1,15.3-27.1,28.4C242.6,178.2,253.9,189.4,269.7,193.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M184.8,155.6c-1.8,1.1-3.7,1.7-5.8,1.7c-8.3,0-15-10-15-22.3s6.7-22.3,15-22.3c2,0,4,0.6,5.8,1.7 c-5.4,3.4-9.2,11.3-9.2,20.6S179.4,152.2,184.8,155.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M338.8,155.6c-1.8,1.1-3.7,1.7-5.8,1.7c-8.3,0-15-10-15-22.3s6.7-22.3,15-22.3c2,0,4,0.6,5.8,1.7 c-5.4,3.4-9.2,11.3-9.2,20.6S333.4,152.2,338.8,155.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBear);
export default __webpack_public_path__ + "static/media/bear.963283d711747bab27c77185d6a5ae59.svg";
export { ForwardRef as ReactComponent };